import * as classNames from "classNames";
import * as React from "react";

export interface ILongLabelsBarChart {
    data: any;
    height?: number;
    itemLabel?: string;
    valueLabel?: string;
    cellCss?: string;
}
export const LongLabelsBarChart = (props: ILongLabelsBarChart) => {
    const { data, height, itemLabel, valueLabel } = props;

    const maxWidth = 100;
    let minValue = data.reduce((a: any, b: any) => (a.value < b.value ? a : b)).value;
    let maxValue = data.reduce((a: any, b: any) => (a.value > b.value ? a : b)).value;
    if (minValue > 0) {minValue = 0;}
    if (maxValue < 0) {maxValue = 0;}
    const minMaxDifference = maxValue - minValue;
    const onePixelValue = maxWidth / minMaxDifference;
    const XAxisTop = Math.round(maxWidth - -minValue * onePixelValue);

    const zeroLinePosition = Math.round(maxWidth - XAxisTop);

    return (
        <div className="long-labels-bar-chart">
            <table>
                <thead>
                    <tr>
                        <th>{itemLabel}</th>
                        <th>{valueLabel}</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((barData: any, index: number) => {
                        const barHeight = Math.abs(Math.round(barData.value * onePixelValue));
                        const barShift = barData.value < 0 ? XAxisTop : XAxisTop - barHeight;

                        return (
                            <tr key={barData.name}>
                                <td className={classNames("llbc-label", props.cellCss )}>{barData.name}</td>
                                <td className="llbc-value">
                                    <div
                                        className={
                                            "llbc-bar " +
                                            (barData.value == 0 ? "zero" : barData.value < 0 ? "negative" : "positive")
                                        }
                                    >
                                        <div
                                            className="llbc-fill"
                                            style={{
                                                width: `${barHeight}%`,
                                                // transform: `translateY(${barShift}px)`,
                                            }}
                                        >
                                            <div className={"llbc-fill-color chart-bg-" + (index + 1)}>
                                                <div className="llbc-figure">{barData.value}%</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
